import { render, staticRenderFns } from "./MemberPreviewComponent.vue?vue&type=template&id=5f16751a&"
import script from "./MemberPreviewComponent.vue?vue&type=script&lang=js&"
export * from "./MemberPreviewComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports